module.exports = __webpack_public_path__ + "img/cover-casino-bg.5e8f13b8.jpg";